import PropTypes from 'prop-types';
import Icon from "../../../Display/Icon/Icon";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function MoreResultsButton(_ref) {
  let {
    moreCount,
    onClick
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: "more-results__btn flex justify-center items-center p-4",
    children: /*#__PURE__*/_jsxs("button", {
      type: "button",
      onClick: onClick,
      className: "flex justify-center items-center hover:cursor-pointer p-2",
      children: [/*#__PURE__*/_jsx("span", {
        className: "underline text-current-blue",
        children: "See ".concat(moreCount, " more result").concat(moreCount > 1 ? 's' : '')
      }), /*#__PURE__*/_jsx(Icon, {
        icon: "ChevronArrow",
        className: "ml-2 rotate-180"
      })]
    })
  });
}
MoreResultsButton.propTypes = {
  moreCount: PropTypes.number,
  onClick: PropTypes.func
};
MoreResultsButton.defaultProps = {
  moreCount: 0,
  onClick: () => {}
};
export default MoreResultsButton;
//# sourceMappingURL=MoreResultsButton.js.map